import $ from "jquery";

export function clickOnMaterialElement(name: string) {
	console.log("clicking on material", name);
	$(`.pplr-choose-material [data-value="${name}"]`).trigger("click");
}
